import './App.scss';
import {
  Routes,
  Route,
  HashRouter,
} from "react-router-dom";
import Home from './Home/'
import CMS from './CMS/'
import { initializeFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { AuthProvider, useFirebaseApp, FirestoreProvider, useInitFirestore, StorageProvider, FunctionsProvider } from 'reactfire';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions'
import { useEffect, useState } from 'react';
function FirestoreWrapper(props) {
  const{ fontLoaded } = props;
  const {status, data: firestoreInstance} = useInitFirestore(async (firebaseApp) => {
    const db = initializeFirestore(firebaseApp, {});
    try {
      await enableIndexedDbPersistence(db);
    } catch (error) {
      console.warn(error)
    }
    return db;
  });

  if (status === 'loading') {
    return ''
  }
  let router = fontLoaded ? (
    <HashRouter>
      <Routes>
        <Route path="/cms/*" element={<CMS />} />
        <Route path='/*' element={<Home />} />
      </Routes>
    </HashRouter>
  ) : null
  return (
    <FirestoreProvider sdk={firestoreInstance}>
      {router}
    </FirestoreProvider>
  )
}

function App() {
  const firebaseApp = useFirebaseApp();
  const auth = getAuth(firebaseApp);
  const storage = getStorage(firebaseApp)
  const functions = getFunctions(firebaseApp)

  const [fontLoaded, setFontLoaded] = useState(false);
  useEffect(() => {
    document.fonts.ready.then(() => {
      setFontLoaded(true)
    })
  }, [])
  return (
    <div className='App'>
      <AuthProvider sdk={auth}>
        <StorageProvider sdk={storage}>
          <FunctionsProvider sdk={functions}>

            <FirestoreWrapper fontLoaded={fontLoaded} />
          </FunctionsProvider>
        </StorageProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
